export function applicationsJson (language) {
  let items

  if (language === 'es') {
    items = {
      editCategoryApplication: {
        name: 'editCategoryApplication',
        label: 'categorizar aplicaciones'
      }
    }
  } else if (language === 'en') {
    items = {
      editCategoryApplication: {
        name: 'editCategoryApplication',
        label: 'categorize apps'
      }
    }
  }
  return (items)
}
